import SearchBarUserName from "../search-bar/SearchBarUserName";
import {Field} from "formik";
import React from "react";
import useFilterUser from "../../custom-hooks/useFilterUser";
import useSortItems from "../../custom-hooks/useSortItems";
import {useSelector} from "react-redux";
import styled from "styled-components";

const SelectStakeInputFormik = ({stakeSelected = [], stakeId, limitedItems=false, initialStake}) => {
    const {sortOneItemTopOfTheList} = useSortItems()
    const {stakes} = useSelector(state => state.stakes)
    const sortedStakes = sortOneItemTopOfTheList(limitedItems ? stakeSelected : stakes, {id: Number(initialStake)})

    const {
        query,
        setQuery
    } = useFilterUser(stakes)

    return (
        <div>
            <label> Enjeu : </label>
            <SearchBarUserName
                setQuery={setQuery}
                name={'enjeu'}
            />
            <Wrapper>
                <Axis>
                    {sortedStakes.length > 0 &&
                    sortedStakes
                        .filter(a => a.name.toLowerCase().includes(query.toLowerCase()))
                        .map(a => (
                            <InputContainer key={a.id + '/' + a.name}>
                                <label>
                                    <Field
                                        type={"radio"}
                                        name={'stakeId'}
                                        value={a.id}
                                        checked={a.id.toString() === stakeId?.toString()}
                                    />
                                    <Name>
                                        <p> {a.name} </p>
                                    </Name>
                                </label>
                            </InputContainer>
                        ))}
                </Axis>
            </Wrapper>
        </div>
    )
}
const Wrapper = styled.div`
  height: 120px;
  overflow-y: auto;
`

const Axis = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
`
const Name = styled.div`
  border: 1px solid var(--color-purple-lighten);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  width: fit-content;

  p {
    font-weight: 500;
  }

  :hover {
    background: var(--color-purple-06);

    p {
      color: var(--color-white);
    }
  }

`

const InputContainer = styled.div`
  overflow: hidden;

  label > input {
    opacity: 0;
    display: none;
  }

  label > input:checked + div {
    background-color: var(--color-purple-06);

    p {
      color: var(--color-white);
    }
  }
`


export default SelectStakeInputFormik